export default {
    'barbara': {
        text: `<p>
					Barbara Minto holds an MBA from the Harvard Business School. Her Course reflects insights drawn from more than 30 years of
					conducting courses worldwide at major consulting firms and corporations. Indeed, the phrase “Take this and make it Minto”
					is common in many of these organizations and the Minto Pyramid Principle is considered the ‘lingua franca’ for serious-minded
					professionals, especially those who want to be listened to and earnestly wish to advance their careers.
				</p>
				<!-- <p>Barbara Minto’s Wikipedia page.</p> -->`
    }
}





// WEBPACK FOOTER //
// ./client/app/modules/site/barbara/i18n/es.js